import { render, staticRenderFns } from "./MergeItemRow.vue?vue&type=template&id=1ac4840c&scoped=true&lang=pug&"
import script from "./MergeItemRow.vue?vue&type=script&lang=js&"
export * from "./MergeItemRow.vue?vue&type=script&lang=js&"
import style0 from "./MergeItemRow.vue?vue&type=style&index=0&id=1ac4840c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4840c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
